import { render, staticRenderFns } from "./CodiciIcdIxListComponent.vue?vue&type=template&id=718cdb9e"
import script from "./CodiciIcdIxListComponent.vue?vue&type=script&lang=js"
export * from "./CodiciIcdIxListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports